import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import TronAddress from '@/components/TronAddress.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/address/:address?',
    name: 'address',    
    component: TronAddress,
    props: route => ({ address: route.params.address }),
    children: [
      {
        path: '',
        name: 'AddressTransfers',
        component: () => import('@/views/address/AddressTransfers.vue'),
      },      
      {
        path: 'internal-transactions',
        name: 'AddressInternal',
        component: () => import('@/views/address/AddressInternal.vue'),
      },
      {
        path: 'freeze',
        name: 'AddressFreeze',
        component: () => import('@/views/address/AddressFreeze.vue'),
      },
      {
        path: 'contracts',
        name: 'AddressContracts',
        component: () => import('@/views/address/AddressContracts.vue'),
      },
      {
        path: 'analysis',
        name: 'AddressAnalysis',
        component: () => import('@/views/address/AddressAnalysis.vue'),
      },
      {
        path: 'permissions',
        name: 'AddressPermissions',
        component: () => import('@/views/address/AddressPermissions.vue'),
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
